import React from "react";
import { createRoot } from "react-dom/client";
import AircraftAccidentsIncidentsData from "./AircraftAccidentsIncidentsData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderAircraftAccidentsIncidentsData: unknown;
	}
}

export function renderAircraftAccidentsIncidentsData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<AircraftAccidentsIncidentsData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderAircraftAccidentsIncidentsData =
	renderAircraftAccidentsIncidentsData;
